import React from 'react';
import { useDispatch } from 'react-redux';
// import Dialog from './components/Dialog';
import * as config from '../config';
import _ from 'lodash';
import { useParams, useHistory } from 'react-router-dom';
import { Link as RouteLink } from 'react-router-dom';
import { web3dData } from '../data-source';
import { Breadcrumbs, Link, Toolbar, Typography, Dialog } from '@mui/material';
import { getArticlesById, getProductByTid } from '@ivymobi/orbit-core/business/productCenter';
import { TenantContext, UserContext } from '../../orbit-context';
import { connect, useSolutionContext } from '../context';
import ShareContent from '../components/Share'

const PreviewDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams<any>() ?? { id: null };
  const url = web3dData?.[id]?.web3d?.url;
  const [mode, setMode] = React.useState('normal')
  const sceneConfig = config.scenesConfig.find(i => i.productId === id);
  const history = useHistory();
  const tenant = React.useContext(TenantContext);
  const { openDialog } = useSolutionContext();

  const handleShare = () => {
    setMode('share')
  }
  const handleClose = () => {
    setMode('normal')
  }

  React.useEffect(() => {
    const onMessage = (event) => {
      console.log('home onMessage --------->>', event.data);
      // const { history, module } = this.props;
      // const prefix = _.get(module, 'config.general.router.prefix');
      if (event.data.type === 'playcanvas:hotspot') {
        const product = config.hotspotConfig[event.data.data];
        if (product && product.type === 'detail') {
          console.log('2 product = ', product);
          // this.hotspotClicked(this.getProduct(product.id));

          dispatch(getArticlesById({ user: { token: null, user: null }, tenant: { id: tenant.id }, id: product.id })).then((res) => {
            console.log("======res===", res)
            if (res && res.data && res.data[0]) {
              console.log('文章详情（暂时没有产品列表，测试数据见上面的 testData ） = ', res.data[0])
              openDialog(res.data[0]);
            }
          })

          //进入2D场景
        } else if (product && product.type === 'mid_2d') {
          history.push(`/solutions/${product.id}`);
          //进入3D场景
        } else if (product && product.type === 'mid_3d') {
          history.push(`/solutions/previewDetail/${product.id}`);
        }
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };

  }, []);

  return <div style={{ position: 'absolute', left: 0, top: 60, right: 0, bottom: 0 }}>
    <Toolbar style={{ padding: '0px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Breadcrumbs>
        <Link onClick={() => {
        }} component={RouteLink} to={'/'}>
          首页
        </Link>
        <Link onClick={() => {
        }} component={RouteLink} to={'/solutions'}>
          解决方案
        </Link>
        {
          sceneConfig?.belongTo && <Link onClick={() => {
          }} component={RouteLink} to={sceneConfig?.belongTo?.type === 'mid_3d' ? `/solutions/previewDetail/${sceneConfig?.belongTo?.id}` : `/solutions/${sceneConfig?.belongTo?.id}`}>
            {sceneConfig?.belongTo?.name}
          </Link>
        }
        <Typography>{sceneConfig?.title}</Typography>;
      </Breadcrumbs>
      {/* <div style={{ height: '100%' }}>
        <div onClick={handleShare}>分享</div>
      </div> */}
    </Toolbar>
    <iframe src={url} style={{ width: '100%', height: 'calc(100% - 64px)', border: 'none' }}></iframe>
    {/* {showPopoverDialog &&
      <Dialog
        className={styles.dialog_component}
        data={dialogData}
        pTitle={this.getTitle()}
        context={'3d'}
        onDialogClose={this.onDialogClose}
        module={module} />
    } */}
    <Dialog open={mode === 'share'} maxWidth="sm" fullWidth onClose={handleClose}>
      <ShareContent />
    </Dialog>
  </div>;
};

export default connect(PreviewDetail);